import React from "react";
import UserHeader from "./Userpages/UserHeader";
import HomeBody from "./Userpages/HomeBody";
import UserFooter from "./Userpages/UserFooter";


function UserHome() {
  return (
    <div>
       
      <UserHeader/>
      <HomeBody/>
      <UserFooter/>
    </div>
  );
}

export default UserHome;
